import React from 'react';

declare global {
    namespace JSX {
        export interface IntrinsicElements {
            'calcite-button': any;
        }
    }
}

type Props = {
    lable: string;
    iconStart?: string;
    onClick?: () => void;
};

const CalciteBtn: React.FC<Props> = ({ lable, iconStart, onClick }: Props) => {
    const btnRef = React.useRef<any>();

    React.useEffect(() => {
        btnRef.current.addEventListener('click', onClick);
    }, []);

    return (
        <calcite-button
            ref={btnRef}
            appearance="solid"
            color="blue"
            scale="m"
            href=""
            dir="ltr"
            alignment="center"
            width="auto"
            icon-start={iconStart}
        >
            {lable}
        </calcite-button>
    );
};

export default CalciteBtn;
